<!-- Toast de mensagens -->
<p-toast position="top-right"></p-toast>

<!-- ===================================================================== -->
<!-- ESTADO: Loading                                                        -->
<!-- ===================================================================== -->
<div *ngIf="isLoading" class="loading-container">
  <p-progressSpinner></p-progressSpinner>
</div>

<!-- ===================================================================== -->
<!-- ESTADO: Erro Timeout                                                   -->
<!-- ===================================================================== -->
<div *ngIf="!isLoading && exibirErro" class="estado-erro-wrapper">
  <!-- Hero Banner Erro -->
  <div class="hero-banner hero-banner--erro">
    <div class="hero-banner__content">
      <div class="hero-banner__icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="hero-banner__text">
        <h1 class="hero-banner__title">{{ 'planos.pagamento_nao_confirmado' | translate }}</h1>
        <p class="hero-banner__subtitle">{{ 'planos.erro_timeout_desc' | translate }}</p>
      </div>
    </div>
    <div class="hero-banner__decorative-circle circle-1" aria-hidden="true"></div>
    <div class="hero-banner__decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="hero-banner__wave" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="#ffffff"/>
    </svg>
  </div>

  <div class="erro-container">
    <div class="erro-card">
      <div class="erro-card__icone">
        <i class="pi pi-refresh"></i>
      </div>
      <p class="erro-card__texto">{{ 'planos.erro_timeout_instrucao' | translate }}</p>
      <button pButton
              [label]="'planos.voltar_planos' | translate"
              icon="pi pi-arrow-left"
              (click)="fecharErro()">
      </button>
    </div>
  </div>
</div>

<!-- ===================================================================== -->
<!-- ESTADO: Processando Pagamento                                          -->
<!-- ===================================================================== -->
<div *ngIf="!isLoading && !exibirErro && planoSelecionado">

  <!-- Hero Banner Processando -->
  <div class="hero-banner" [class.hero-banner--sucesso]="planoAssinado">
    <div class="hero-banner__content">
      <div class="hero-banner__icon-container">
        <i [class]="planoAssinado ? 'pi pi-check-circle' : 'pi pi-credit-card'" aria-hidden="true"></i>
      </div>
      <div class="hero-banner__text">
        <h1 class="hero-banner__title">
          {{ planoAssinado ? ('planos.plano_assinado_sucesso' | translate) : ('planos.processando_titulo' | translate) }}
        </h1>
        <p class="hero-banner__subtitle">{{ planoSelecionado.nome }} &mdash; {{ planoSelecionado.valor | currency:moeda:'symbol-narrow':'1.0-0':locale }}</p>
      </div>
    </div>
    <div class="hero-banner__decorative-circle circle-1" aria-hidden="true"></div>
    <div class="hero-banner__decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="hero-banner__wave" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="#ffffff"/>
    </svg>
  </div>

  <!-- Card de Processamento -->
  <div class="processando-container">
    <div class="processando-card">

      <!-- Timer -->
      <div *ngIf="!planoAssinado" class="processando-card__timer-section">
        <div class="processando-card__timer-icon">
          <i class="pi pi-clock" aria-hidden="true"></i>
        </div>
        <span class="processando-card__timer" aria-live="polite">{{ tempoFormatado }}</span>
        <span class="processando-card__timer-label">{{ 'planos.tempo_restante' | translate }}</span>
      </div>

      <!-- Mensagem de processamento -->
      <p *ngIf="!planoAssinado" class="processando-card__texto">
        {{ 'planos.texto_processando' | translate:{ plano: planoSelecionado.nome } }}
      </p>

      <!-- Imagem QR Code -->
      <div *ngIf="urlQrCode && !planoAssinado" class="processando-card__qrcode">
        <span class="processando-card__qrcode-label">{{ 'planos.escanear_qr' | translate }}</span>
        <img [src]="urlQrCode" [alt]="'planos.qrcode' | translate" />
      </div>

      <!-- Mensagem de sucesso -->
      <div *ngIf="planoAssinado" class="processando-card__sucesso">
        <div class="processando-card__sucesso-icon">
          <i class="pi pi-check" aria-hidden="true"></i>
        </div>
        <h3>{{ 'planos.pagamento_confirmado' | translate }}</h3>
        <p>{{ 'planos.pagamento_confirmado_desc' | translate }}</p>
      </div>

      <!-- Botoes -->
      <div class="processando-card__acoes">
        <button *ngIf="!urlQrCode && !planoAssinado"
                pButton
                [label]="'planos.acessar_pagamento' | translate"
                icon="pi pi-external-link"
                class="p-button-lg"
                (click)="acessarPagamento()">
        </button>

        <button *ngIf="!planoAssinado"
                pButton
                [label]="'planos.cancelar' | translate"
                class="p-button-outlined p-button-secondary"
                icon="pi pi-times"
                (click)="cancelarTransacao()">
        </button>
      </div>

      <!-- Seguranca -->
      <div *ngIf="!planoAssinado" class="processando-card__seguranca">
        <i class="pi pi-lock" aria-hidden="true"></i>
        <span>{{ 'planos.pagamento_seguro' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<!-- ===================================================================== -->
<!-- ESTADO: Lista de Planos (principal)                                    -->
<!-- ===================================================================== -->
<div *ngIf="!isLoading && !exibirErro && !planoSelecionado">

  <!-- Hero Banner -->
  <div class="hero-banner">
    <div class="hero-banner__content">
      <div class="hero-banner__icon-container">
        <i class="pi pi-shield" aria-hidden="true"></i>
      </div>
      <div class="hero-banner__text">
        <h1 class="hero-banner__title">{{ 'planos.hero_titulo' | translate }}</h1>
        <p class="hero-banner__subtitle">{{ 'planos.hero_subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="hero-banner__decorative-circle circle-1" aria-hidden="true"></div>
    <div class="hero-banner__decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="hero-banner__wave" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="#ffffff"/>
    </svg>
  </div>

  <!-- Banner de limite atingido -->
  <div *ngIf="exibirBannerLimite" class="banner-limite" role="alert">
    <p-message severity="error"
               [text]="'planos.texto_limite_atingido' | translate">
    </p-message>
  </div>

  <!-- Limite de usuários — distinto do banner de limite de valor logo acima -->
  <div *ngIf="exibirBannerLimiteUsuarios" class="banner-limite" role="alert">
    <p-message severity="warn"
               [text]="'planos.texto_limite_usuarios_atingido' | translate">
    </p-message>
  </div>

  <!-- Secao Plano Atual -->
  <div *ngIf="inscricaoAtiva" class="plano-atual-container">
    <div class="plano-atual-card" [class.plano-atual-card--carencia]="estaNoPeriodoDeCarencia">
      <div class="plano-atual-card__header">
        <i class="pi pi-star-fill" aria-hidden="true"></i>
        <span>{{ 'planos.plano_atual' | translate }}</span>
      </div>
      <div class="plano-atual-card__body">
        <h3>{{ inscricaoAtiva.plano.nome }}</h3>
        <div class="plano-atual-card__info">
          <div class="plano-atual-card__info-item">
            <i class="pi pi-calendar" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.data_ativacao' | translate }}</span>
              <span class="valor">{{ formatarDataInscricao(inscricaoAtiva.dataDeInscricao) }}</span>
            </div>
          </div>
          <div class="plano-atual-card__info-item">
            <i class="pi pi-calendar-times" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.data_vencimento' | translate }}</span>
              <span class="valor">
                {{ ehPlanoEspecial ? ('planos.sem_vencimento' | translate) : formatarDataInscricao(inscricaoAtiva.dataDeCancelamento) }}
              </span>
            </div>
          </div>
          <div class="plano-atual-card__info-item">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.status' | translate }}</span>
              <p-tag [value]="inscricaoAtiva.status ? ('planos.status_ativo' | translate) : ('planos.status_cancelado' | translate)"
                     [severity]="inscricaoAtiva.status ? 'success' : 'danger'">
              </p-tag>
            </div>
          </div>
          <div class="plano-atual-card__info-item">
            <i class="pi pi-wallet" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.valor_do_plano' | translate }}</span>
              <span class="valor">{{ inscricaoAtiva.plano.valor | currency:moeda:'symbol-narrow':'1.0-0':locale }}</span>
            </div>
          </div>
          <div *ngIf="totalVendas !== undefined" class="plano-atual-card__info-item">
            <i class="pi pi-shopping-cart" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.valor_da_venda' | translate }}</span>
              <span class="valor">{{ totalVendas | currency:moeda:'symbol-narrow':'1.0-0':locale }}</span>
            </div>
          </div>
          <!-- Limite de vendas: ESPECIAL nao tem limite; demais mostram o valor -->
          <div *ngIf="ehPlanoEspecial" class="plano-atual-card__info-item">
            <i class="pi pi-infinity" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.valor_do_limite' | translate }}</span>
              <span class="valor">{{ 'planos.sem_limite_vendas' | translate }}</span>
            </div>
          </div>
          <div *ngIf="!ehPlanoEspecial && limiteDeVendasVigente" class="plano-atual-card__info-item">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.valor_do_limite' | translate }}</span>
              <span class="valor">{{ limiteDeVendasVigente | currency:moeda:'symbol-narrow':'1.0-0':locale }}</span>
            </div>
          </div>
          <!-- Usuarios de acesso: em uso hoje sobre o total permitido. Quando ha acessos
               pagos a mais, detalha de onde vem o total. Some enquanto o limite nao chega. -->
          <div *ngIf="limiteUsuarios" class="plano-atual-card__info-item">
            <i class="pi pi-users" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.usuarios' | translate }}</span>
              <span class="valor">{{ limiteUsuarios.usuariosAtivos }} / {{ limiteUsuarios.limite }}</span>
              <span *ngIf="limiteUsuarios.usuariosExtras > 0" class="plano-atual-card__info-detalhe">
                {{ 'planos.usuarios_contratados_detalhe' | translate:{
                     inclusos: limiteUsuarios.usuariosInclusos,
                     extras: limiteUsuarios.usuariosExtras
                   } }}
              </span>
            </div>
          </div>

          <!-- Fechamento do ciclo (reinicio do limite): nao se aplica ao ESPECIAL -->
          <div *ngIf="!ehPlanoEspecial" class="plano-atual-card__info-item">
            <i class="pi pi-sync" aria-hidden="true"></i>
            <div class="plano-atual-card__info-text">
              <span class="label">{{ 'planos.fechamento_ciclo' | translate }}</span>
              <span class="valor">{{ dataReinicioContagem }}</span>
            </div>
            <button pButton type="button"
                    class="p-button-rounded p-button-text p-button-sm plano-atual-card__info-help"
                    icon="pi pi-question-circle"
                    (click)="exibirDialogCiclo = true"
                    [pTooltip]="'planos.info_ciclo_titulo' | translate"
                    [attr.aria-label]="'planos.info_ciclo_titulo' | translate">
            </button>
          </div>
        </div>

        <!-- Aviso de carencia: somente no mes de vencimento -->
        <div *ngIf="estaNoPeriodoDeCarencia" class="plano-atual-card__carencia">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <span>{{ 'planos.aviso_carencia_vencimento' | translate }}</span>
        </div>

        <!-- Aviso de cancelamento pendente -->
        <div *ngIf="cancelamentoPendente" class="plano-atual-card__cancelamento-pendente">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <span>{{ 'planos.cancelamento_pendente' | translate }}</span>
        </div>

        <!-- Barra de progresso do limite -->
        <div *ngIf="limiteDeVendasVigente" class="plano-atual-card__progresso">
          <div class="plano-atual-card__progresso-label">
            <span>{{ 'planos.uso_do_limite' | translate }}</span>
            <span class="plano-atual-card__progresso-valor">{{ percentualUsoLimite }}%</span>
          </div>
          <p-progressBar
            [value]="percentualUsoLimite"
            [showValue]="false"
            [style]="{ height: '10px' }"
            [styleClass]="percentualUsoLimite >= 80 ? 'progress-danger' : 'progress-success'">
          </p-progressBar>
        </div>
      </div>
    </div>
  </div>

  <!-- Seletor de periodo -->
  <div class="periodo-container">
    <p-selectButton [options]="opcoesPeriodo"
                    [(ngModel)]="periodoSelecionado"
                    (onChange)="alterarPeriodo($event)"
                    optionLabel="label"
                    optionValue="value">
      <ng-template let-item pTemplate>
        <span>{{ item.label }}</span>
        <span *ngIf="item.tag" class="periodo-tag">{{ item.tag }}</span>
      </ng-template>
    </p-selectButton>
  </div>

  <!-- Grid de cards -->
  <div class="planos-grid">
    <div *ngFor="let plano of planosFiltrados" class="plano-grid-item">
      <app-plano-card
        [plano]="plano"
        [planoContratado]="ehPlanoContratado(plano)"
        [ehPlanoDestaque]="ehPlanoDestaqueCalc(plano)"
        [inscricaoAtiva]="inscricaoAtiva"
        [cancelamentoPendente]="cancelamentoPendente"
        [emCarencia]="estaNoPeriodoDeCarencia && ehPlanoContratado(plano)"
        [percentualContador]="percentualContador"
        [nomeContador]="nomeContador"
        [percentualIndicacao]="percentualIndicacao"
        [codigoCupomIndicacao]="codigoCupomIndicacao"
        [moeda]="moeda"
        [locale]="locale"
        (selecionarPlano)="abrirDialogPagamento($event)"
        (cancelarAssinaturaEvt)="confirmarCancelamento()">
      </app-plano-card>
    </div>
  </div>

  <!-- Beneficios -->
  <div class="beneficios-section">
    <div class="beneficio-item">
      <div class="beneficio-item__icon beneficio-item__icon--vendas">
        <i class="pi pi-chart-line" aria-hidden="true"></i>
      </div>
      <span class="beneficio-item__texto">{{ 'planos.beneficio_vendas' | translate }}</span>
    </div>
    <div class="beneficio-item">
      <div class="beneficio-item__icon beneficio-item__icon--relatorios">
        <i class="pi pi-file-edit" aria-hidden="true"></i>
      </div>
      <span class="beneficio-item__texto">{{ 'planos.beneficio_relatorios' | translate }}</span>
    </div>
    <div class="beneficio-item">
      <div class="beneficio-item__icon beneficio-item__icon--suporte">
        <i class="pi pi-headphones" aria-hidden="true"></i>
      </div>
      <span class="beneficio-item__texto">{{ 'planos.beneficio_suporte' | translate }}</span>
    </div>
  </div>
</div>

<!-- ===================================================================== -->
<!-- DIALOG: Forma de Pagamento (wave header)                               -->
<!-- ===================================================================== -->
<p-dialog
  [(visible)]="exibirDialogPagamento"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '35rem', height: 'auto' }">

  <!-- Header customizado com wave -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-credit-card" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'planos.titulo_forma_pagamento' | translate }}</h2>
        <p>{{ 'planos.subtitulo_forma_pagamento' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- Corpo do dialog -->
  <div class="dialog-wave-body">
    <!-- Campo de cupom: oculto quando ja ha desconto que nao acumula — contador OU
         indicacao vigente (R15). A origem "Desconto de indicacao: X%" abaixo serve de feedback. -->
    <div *ngIf="!bloquearCampoCupom" class="field">
      <label>{{ 'planos.cupom' | translate }}</label>
      <div class="cupom-container">
        <input type="text"
               pInputText
               class="w-full"
               [(ngModel)]="cupomTexto"
               [placeholder]="'planos.cupom' | translate"
               (keydown.enter)="verificarCupom()" />
        <button pButton
                [label]="'planos.aplicar' | translate"
                [loading]="carregandoCupom"
                (click)="verificarCupom()">
        </button>
      </div>
    </div>

    <!-- Aviso: o contador ja aplica desconto (substitui o campo de cupom). Some quando ha
         cupom especial aplicado, que vence a precedencia e define o valor sozinho. -->
    <div *ngIf="temDescontoContador && !temCupomEspecial" class="aviso-desconto-contador">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>{{ 'planos.desconto_contador_aviso' | translate:{ percentual: percentualContador } }}</span>
    </div>

    <!-- Condicoes especiais: o cupom nao desconta, ele DEFINE a contratacao. Substitui o
         bloco de desconto do resumo, para o cliente ver exatamente o que vai contratar. -->
    <div *ngIf="temCupomEspecial" class="condicoes-especiais">
      <div class="condicoes-especiais__cabecalho">
        <i class="pi pi-star-fill" aria-hidden="true"></i>
        <span>{{ 'planos.condicoes_especiais_titulo' | translate }}</span>
      </div>
      <ul class="condicoes-especiais__lista">
        <li>
          <span class="condicoes-especiais__rotulo">{{ 'planos.condicoes_especiais_valor' | translate }}</span>
          <strong *ngIf="!temCupomCortesia">{{ valorCupomEspecial! | currency:moeda:'symbol-narrow':'1.0-0':locale }}</strong>
          <strong *ngIf="temCupomCortesia">{{ 'planos.condicoes_especiais_sem_cobranca' | translate }}</strong>
        </li>
        <li *ngIf="periodoCupomEspecial">
          <span class="condicoes-especiais__rotulo">{{ 'planos.condicoes_especiais_periodo' | translate }}</span>
          <strong>{{ 'planos.condicoes_especiais_dias' | translate:{ dias: periodoCupomEspecial } }}</strong>
        </li>
        <li *ngIf="limiteCupomEspecial !== null">
          <span class="condicoes-especiais__rotulo">{{ 'planos.condicoes_especiais_limite' | translate }}</span>
          <strong>{{ limiteCupomEspecial! | currency:moeda:'symbol-narrow':'1.0-0':locale }}</strong>
        </li>
      </ul>
    </div>

    <!-- Resumo do plano selecionado -->
    <div *ngIf="planoParaDialog" class="resumo-plano">
      <span class="resumo-plano__label">{{ 'planos.plano_selecionado' | translate }}:</span>
      <span class="resumo-plano__nome">{{ planoParaDialog.nome }}</span>
      <span class="resumo-plano__preco"
            [class.resumo-plano__preco--riscado]="temCupomEspecial || (temDescontoContador && valorComDescontoContador(planoParaDialog) !== null) || (temDescontoIndicacaoDialog && valorComDescontoIndicacaoDialog(planoParaDialog) !== null)">
        {{ planoParaDialog.valor | currency:moeda:'symbol-narrow':'1.0-0':locale }}
      </span>
      <!-- Preco com desconto do contador (espelho do card; precedencia sobre cupom) -->
      <span *ngIf="temDescontoContador && !temCupomEspecial && valorComDescontoContador(planoParaDialog) !== null"
            class="resumo-plano__preco-contador">
        {{ valorComDescontoContador(planoParaDialog)! | currency:moeda:'symbol-narrow':'1.0-0':locale }}
      </span>
      <!-- Preco com desconto de indicacao (auto-aplicado na cobranca — R15). Some quando
           ha contador ou cupom digitado aplicado (precedencia, tratada no getter). -->
      <span *ngIf="temDescontoIndicacaoDialog && valorComDescontoIndicacaoDialog(planoParaDialog) !== null"
            class="resumo-plano__preco-contador">
        {{ valorComDescontoIndicacaoDialog(planoParaDialog)! | currency:moeda:'symbol-narrow':'1.0-0':locale }}
      </span>
      <!-- Origem do desconto de indicacao: "Desconto de indicacao: X% (cupom Y)" -->
      <span *ngIf="temDescontoIndicacaoDialog && valorComDescontoIndicacaoDialog(planoParaDialog) !== null"
            class="resumo-plano__desconto-cupom-percentual">
        {{ 'planos.desconto_indicacao_origem' | translate:{ percentual: (percentualIndicacaoDialog | number:'1.0-2':locale), cupom: codigoCupomIndicacaoDialog } }}
      </span>
      <!-- Preco com cupom (comum ou especial). Na cortesia nao aparece: o bloco de condicoes
           ja diz "Sem cobranca", e um "(Cupom: 0 Gs)" ao lado so confundiria. -->
      <span *ngIf="cupomAplicado && !temCupomCortesia && valorComDesconto(planoParaDialog.valor) !== null"
            class="resumo-plano__preco-cupom">
        ({{ 'planos.cupom' | translate }}: {{ valorComDesconto(planoParaDialog.valor)! | currency:moeda:'symbol-narrow':'1.0-0':locale }})
      </span>
      <!-- Percentual de desconto: so no cupom COMUM. No especial nao existe percentual — o
           valor negociado ja e o final e aparece no bloco de condicoes especiais. -->
      <span *ngIf="cupomAplicado && !temCupomEspecial && valorComDesconto(planoParaDialog.valor) !== null"
            class="resumo-plano__desconto-cupom-percentual">
        {{ 'planos.desconto_cupom_percentual' | translate:{ percentual: (cupomAplicado.porcentagemDesconto | number:'1.0-2':locale) } }}
      </span>
    </div>

    <!-- Usuarios de acesso adicionais: cobrados pelo periodo inteiro do plano contratado.
         Some no plano gratuito e no ESPECIAL, que nao tem periodo a cobrar. -->
    <div *ngIf="planoParaDialog && podeContratarUsuariosNoDialog(planoParaDialog)"
         class="usuarios-extras">
      <div class="usuarios-extras__cabecalho">
        <span class="usuarios-extras__titulo">
          <i class="pi pi-users" aria-hidden="true"></i>
          {{ 'planos.usuarios_adicionais' | translate }}
        </span>
        <span class="usuarios-extras__preco">
          {{ 'planos.usuarios_adicionais_preco' | translate:{
               valor: (precoMensalUsuario(planoParaDialog) | currency:moeda:'symbol-narrow':'1.0-0':locale)
             } }}
        </span>
      </div>

      <p class="usuarios-extras__ajuda">
        {{ 'planos.usuarios_adicionais_ajuda' | translate:{ inclusos: usuariosInclusos(planoParaDialog) } }}
      </p>

      <div class="usuarios-extras__controle">
        <button pButton type="button" icon="pi pi-minus"
                class="p-button-rounded p-button-outlined"
                [disabled]="usuariosExtras <= 0"
                [attr.aria-label]="'planos.usuarios_adicionais_remover' | translate"
                (click)="alterarUsuariosExtras(-1)"></button>
        <span class="usuarios-extras__quantidade">{{ usuariosExtras }}</span>
        <button pButton type="button" icon="pi pi-plus"
                class="p-button-rounded p-button-outlined"
                [disabled]="usuariosExtras >= MAX_USUARIOS_EXTRAS"
                [attr.aria-label]="'planos.usuarios_adicionais_adicionar' | translate"
                (click)="alterarUsuariosExtras(1)"></button>
      </div>

      <div *ngIf="usuariosExtras > 0" class="usuarios-extras__subtotal">
        {{ 'planos.usuarios_adicionais_subtotal' | translate }}:
        <strong>{{ valorUsuariosExtras(planoParaDialog) | currency:moeda:'symbol-narrow':'1.0-0':locale }}</strong>
      </div>
    </div>

    <!-- Total do checkout: plano + usuarios adicionais, ja com o desconto vigente -->
    <div *ngIf="planoParaDialog && usuariosExtras > 0 && podeContratarUsuariosNoDialog(planoParaDialog)"
         class="resumo-total">
      <span class="resumo-total__label">{{ 'planos.total_a_pagar' | translate }}</span>
      <span class="resumo-total__valor">
        {{ valorTotalDialog(planoParaDialog) | currency:moeda:'symbol-narrow':'1.0-0':locale }}
      </span>
    </div>

    <!-- Botoes de pagamento. Cupom de cortesia nao tem o que cobrar: um botao so, que
         contrata direto, sem abrir link nem QR. -->
    <div class="pagamento-botoes">
      <ng-container *ngIf="temCupomCortesia; else botoesDePagamento">
        <button pButton
                [label]="'planos.contratar' | translate"
                icon="pi pi-check"
                [loading]="carregandoContratacao"
                (click)="contratarComCupom()">
        </button>
      </ng-container>
      <ng-template #botoesDePagamento>
        <button pButton
                [label]="'planos.assinar' | translate"
                icon="pi pi-wallet"
                (click)="assinarPlano()">
        </button>
        <button pButton
                [label]="'planos.qrcode' | translate"
                icon="pi pi-qrcode"
                (click)="gerarQrCode()">
        </button>
      </ng-template>
    </div>
  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <button pButton
            [label]="'planos.cancelar' | translate"
            class="p-button-secondary"
            (click)="exibirDialogPagamento = false">
    </button>
  </ng-template>
</p-dialog>

<!-- ===================================================================== -->
<!-- DIALOG: Explicacao do fechamento do ciclo (wave header)                -->
<!-- ===================================================================== -->
<p-dialog
  [(visible)]="exibirDialogCiclo"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '32rem', height: 'auto' }">

  <!-- Header customizado com wave -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-sync" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'planos.info_ciclo_titulo' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- Corpo do dialog -->
  <div class="dialog-wave-body">
    <p class="info-ciclo__intro">{{ 'planos.info_ciclo_intro' | translate }}</p>

    <div class="info-ciclo__item">
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      <div class="info-ciclo__item-text">
        <strong>{{ 'planos.info_ciclo_limite_titulo' | translate }}</strong>
        <span>{{ 'planos.info_ciclo_limite_desc' | translate }}</span>
      </div>
    </div>

    <div class="info-ciclo__item">
      <i class="pi pi-shopping-cart" aria-hidden="true"></i>
      <div class="info-ciclo__item-text">
        <strong>{{ 'planos.info_ciclo_venda_titulo' | translate }}</strong>
        <span>{{ 'planos.info_ciclo_venda_desc' | translate }}</span>
      </div>
    </div>

    <div class="info-ciclo__item">
      <i class="pi pi-sync" aria-hidden="true"></i>
      <div class="info-ciclo__item-text">
        <strong>{{ 'planos.info_ciclo_reinicio_titulo' | translate }}</strong>
        <span>{{ 'planos.info_ciclo_reinicio_desc' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <button pButton
            [label]="'planos.entendi' | translate"
            (click)="exibirDialogCiclo = false">
    </button>
  </ng-template>
</p-dialog>

<!-- ===================================================================== -->
<!-- DIALOG: Confirmação de Cancelamento (wave header)                      -->
<!-- ===================================================================== -->
<p-dialog
  [(visible)]="cancelDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }"
  (onShow)="onCancelDialogShow()">

  <!-- Header azul com onda SVG -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'common.confirmacao' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- Corpo com mensagem -->
  <div class="dialog-wave-body">
    <p>{{ 'planos.confirmar_cancelamento' | translate }}</p>
  </div>

  <!-- Rodapé com botões -->
  <ng-template pTemplate="footer">
    <button pButton
            [label]="('planos.cancelar' | translate) + ' (Esc)'"
            class="p-button-secondary"
            (click)="cancelDialogVisible = false">
    </button>
    <button #cancelConfirmBtn pButton
            [label]="('common.confirmar' | translate) + ' (Enter)'"
            icon="pi pi-exclamation-triangle"
            style="gap: 0.35rem"
            (click)="cancelarAssinatura()">
    </button>
  </ng-template>
</p-dialog>
